import React, { FC } from "react";

import { useInsuranceLabels } from "../Utils/Context/labelsContext";

import { BookingForm } from "../View/BookingForm/BookingForm";

import { TreaterGeneralInfo } from "../View/Treater/TreaterGeneralInfo/TreaterGeneralInfo";
import { GoBack } from "../View/GoBack";
import { TreaterNotes } from "../View/Treater/TreaterNotes/TreaterNotes";
import { InsuranceTreaterParams } from "../../../Pages/InsuranceTreater/InsuranceTreaterParams.csharp";

export const TreaterPage: FC<InsuranceTreaterParams> = (props) => {
  const {
    isAuthenticated,
    doctor,
    clinics,
    locations,
    services,
    specializations,
    practicalInfo,
    loginUrl,
  } = props;

  const { buttons } = useInsuranceLabels();

  return (
    <div className="insuranceBody insurancePageWithForm">
      <div className="insurancePageWithForm__controls">
        <GoBack label={buttons.goToListViewButtonLabel} />
      </div>
      <div className="insurancePageWithForm__info">
        <TreaterGeneralInfo
          insurancePracticalInfo={practicalInfo}
          doctor={doctor}
          clinics={clinics}
        />
        {isAuthenticated && (
          <TreaterNotes doctorId={doctor?.id} notes={doctor?.notes} />
        )}
      </div>
      <div style={{ display: "none" }} className="insurancePageWithForm__form">
        <BookingForm
          doctor={doctor}
          locations={locations}
          services={services}
          specializations={specializations}
          isAuthenticated={isAuthenticated}
          loginUrl={loginUrl}
        />
      </div>
    </div>
  );
};
